import { combineReducers } from 'redux';

import byId from './byId/reducer';
import byPage from './byPage/reducer';

export default combineReducers({
  byId,
  byPage
});



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/chatResources/reducer.js
 **/